import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { changePassword } from "./admin_helper";

function PasswordChange({ onFinish, onStateChange }) {

    const validateInputs = () => {
        return true;
    }

    const handlePasswordChange = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const old_pass = data.get("old_pass");
        const new_pass = data.get("new_pass");
        const re_pass = data.get("re_pass");
        var flag = true;
        if (old_pass.length < 1 || new_pass.length < 3) {
            flag = false;
            onFinish({ severity: "warning", message: "Incorrect password entered." });
        }
        if (new_pass !== re_pass) {
            flag = false;
            onFinish({ severity: "warning", message: "Password and re-password must be same." });
        }
        if (flag) {
            const _json = { "old_pass": old_pass, "new_pass": new_pass };
            onStateChange(true);
            changePassword(_json).then((res) => {
                onFinish({ severity: "success", message: "Password changed successfully." });
                onStateChange(false);
                console.log(res);
            }).catch((err) => {
                console.error(err);
                onStateChange(false);
                onFinish({ severity: "error", message: err.message });
            });
        }
    }

    return (
        <Box component="form" onSubmit={handlePasswordChange}>
            <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="old_pass" fullWidth type="text" placeholder="Current Password" label="Current Password" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="new_pass" fullWidth type="password" placeholder="New Password" label="New Password" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="re_pass" fullWidth type="password" placeholder="Re-Type Password" label="New Password Again" />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Password Change</Button>
                </Grid>
            </Grid>
        </Box>
    );
}
export default PasswordChange;